import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedVacationDaysDocument,
  AddVacationDaysMutation,
  AddVacationDaysMutationVariables,
  AddVacationDaysDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for creating a vacation day and handling the necessary cache updates.
 * @returns {Object} - Contains the createVacationDayMutation function, loading state, and error state.
 */
export default function useAddVacationDayMutationHook(): { addVacationDayMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [addVacationDayMutation, { loading, error }] = useMutation<AddVacationDaysMutation, AddVacationDaysMutationVariables>(
    AddVacationDaysDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedVacationDays");

        toast(CustomToastComponent, {
          toastId: "vacation-day-added-success",
          data: {
            title: t("toasts.vacationdaysaddedsuccessfully"),
            type: "success"
          }
        });
      },
      refetchQueries: [
        {
          query: PaginatedVacationDaysDocument,
          variables: {
            first: 10,
            currentPage: 0,
            after: null,
            filters: {
              activeFrom: null,
              lengthOfEmployment: null,
              days: null,
              provinces: null
            },
            sort: null
          }
        }
      ]
    });

  return {
    addVacationDayMutation,
    loading,
    error
  };
}
